import { render, staticRenderFns } from "./FilterCollapse.vue?vue&type=template&id=1b1382e4"
import script from "./FilterCollapse.vue?vue&type=script&lang=js"
export * from "./FilterCollapse.vue?vue&type=script&lang=js"
import style0 from "./FilterCollapse.vue?vue&type=style&index=0&id=1b1382e4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports